// extracted by mini-css-extract-plugin
export default {"switchComponentDisabled":"SwtchSigma_switchComponentDisabled__OSbZp","switchComponent":"SwtchSigma_switchComponent__w9kF8","switchContainer":"SwtchSigma_switchContainer__6dWwp"};